import {
  tv
} from "./chunk-N2KXC5ZE.mjs";

// src/components/typography.ts
var typography = tv({
  slots: {
    base: "antialiased"
  },
  variants: {
    variant: {
      title: {
        base: "font-bold text-neutral-900"
      },
      subtitle: {
        base: "font-medium text-neutral-500"
      },
      body: {
        base: "font-normal text-neutral-500"
      },
      assistant: {
        base: "font-medium text-neutral-500"
      }
    },
    size: {
      default: {},
      t1: {},
      t2: {},
      t3: {},
      t4: {},
      t5: {},
      t6: {},
      t7: {},
      t8: {}
    },
    weight: {
      default: {},
      black: {
        base: "font-black"
      },
      bold: {
        base: "font-bold"
      },
      semibold: {
        base: "font-semibold"
      },
      medium: {
        base: "font-medium"
      },
      regular: {
        base: "font-normal"
      },
      light: {
        base: "font-light"
      }
    },
    color: {
      default: {},
      primary: {
        base: "text-fx-primary"
      },
      secondary: {
        base: "text-fx-secondary"
      },
      tertiary: {
        base: "text-fx-tertiary"
      },
      success: {
        base: "text-fx-success"
      },
      warningY: {
        base: "text-fx-warningY"
      },
      warningO: {
        base: "text-fx-warningO"
      },
      danger: {
        base: "text-fx-danger"
      },
      textoPrimario: {
        base: "text-neutral-900"
      },
      textoSecundario: {
        base: "text-neutral-500"
      },
      placeholder: {
        base: "text-neutral-400"
      }
    }
  },
  defaultVariants: {
    variant: "body",
    size: "default",
    weight: "default"
  },
  compoundVariants: [
    {
      variant: "title",
      size: "t1",
      class: {
        base: "text-[48px] leading-[60px]"
      }
    },
    {
      variant: "title",
      size: "t2",
      class: {
        base: "text-[36px] leading-[52px]"
      }
    },
    {
      variant: "title",
      size: "t3",
      class: {
        base: "text-[30px] leading-[32px]"
      }
    },
    {
      variant: "title",
      size: "t4",
      class: {
        base: "text-2xl leading-[32px]"
      }
    },
    {
      variant: "title",
      size: "t5",
      class: {
        base: "text-xl leading-[32px]"
      }
    },
    {
      variant: "title",
      size: "t6",
      class: {
        base: "text-lg leading-[32px]"
      }
    },
    {
      variant: "title",
      size: "t7",
      class: {
        base: "text-base"
      }
    },
    {
      variant: "title",
      size: "t8",
      class: {
        base: "text-sm leading-[20px]"
      }
    },
    {
      variant: ["subtitle", "body"],
      size: "t1",
      class: {
        base: "text-lg leading-[28px]"
      }
    },
    {
      variant: ["subtitle", "body"],
      size: "t2",
      class: {
        base: "text-base leading-[24px]"
      }
    },
    {
      variant: ["subtitle", "body"],
      size: ["t3", "t4", "t5", "t6", "t7"],
      class: {
        base: "text-sm leading-[20px]"
      }
    },
    {
      variant: "assistant",
      size: "t1",
      class: {
        base: "text-xs leading-[18px]"
      }
    },
    {
      variant: "assistant",
      size: "t2",
      class: {
        base: "text-[10px] leading-[16px]"
      }
    },
    {
      variant: "assistant",
      size: ["t3", "t4", "t5", "t6", "t7"],
      class: {
        base: "text-[8px] leading-[10px]"
      }
    }
  ]
});

export {
  typography
};
